module.exports = __webpack_public_path__ + "front/img/9.4f1c1377.png";